<script>
import AdminLayout from '@layouts/admin-main'
import { fetchGroupList, deleteGroup } from '@apis/admin/member'
import MemberGroupInfo from '@components/admin/member-group-info'
import date from 'locutus/php/datetime/date'

export default {
  page: {
    title: 'MemberGroupList',
    meta: [{ name: 'description', content: 'MemberGroupList' }],
  },
  components: { AdminLayout, MemberGroupInfo },
  data() {
    return {
      group_list: [],
      loading: false,
      show_group_info: false,
      target_group_seq: 0,
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    date,
    init() {
      Promise.all([this.loadGroupList()]).catch((e) =>
        this.$toasted.error(e.message)
      )
    },
    async loadGroupList() {
      const { data } = await fetchGroupList()
      this.group_list = data
    },
    handleCreateGroup() {
      this.show_group_info = true
      this.target_group_seq = null
    },
    handleUpdateGroup({ seq }) {
      this.show_group_info = true
      this.target_group_seq = seq
    },
    handleGroupSubmit(seq) {
      this.init()
      this.target_group_seq = seq
    },
    async handleDeleteGroup(seq) {
      try {
        if (
          !(await this.$confirm(
            this.$t('admin.confirm_delete'),
            this.$t('admin.modal_confirm'),
            {
              type: 'warning',
            }
          ).catch(() => false))
        )
          return

        await deleteGroup(seq)
        await this.loadGroupList()
      } catch (e) {
        this.$toasted.error(e.message)
      }
    },
  },
}
</script>

<template>
  <AdminLayout>
    <div :class="$style.adminLeftContent">
      <h3 :class="$style.xeAdmin">{{
        $t('member_group_list.membership_group')
      }}</h3>
      <table cellspacing="0" cellpadding="0" :class="$style.crossTable">
        <thead>
          <tr>
            <th scope="col"
              ><div>{{ $t('admin.form_info_list_order') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('admin.user_name') }}</div></th
            >
            <th scope="col"
              ><div>{{ $t('admin.title') }}</div></th
            >

            <th scope="col"
              ><div>{{ $t('admin.regdate') }}</div></th
            >
            <th scope="col">
              <div :class="$style.tRight">
                <a
                  href="#"
                  :class="[$style.button, $style.black]"
                  @click.prevent="handleCreateGroup"
                  ><span>{{ $t('admin.add') }}</span></a
                >
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="group in group_list" :key="group.seq">
            <td :class="[$style.tCenter, $style.nowrap]">{{
              group.list_order
            }}</td>
            <td :class="[$style.tCenter, $style.nowrap]">{{ group.name }}</td>
            <td :class="[$style.wide]">{{ group.title }}</td>

            <td :class="[$style.tCenter, $style.nowrap]">{{
              date('Y-m-d H:i:s', new Date(group.regdate))
            }}</td>
            <td :class="[$style.tRight, $style.nowrap]">
              <a
                href="#"
                :class="[$style.button]"
                @click.prevent="handleUpdateGroup(group)"
                ><span>{{ $t('admin.modify') }}</span></a
              >
              {{ ' ' }}
              <a
                href="#"
                :class="[$style.button, $style.red]"
                @click.prevent="handleDeleteGroup(group.seq)"
                ><span>{{ $t('admin.delete') }}</span></a
              >
            </td>
          </tr>
          <tr v-if="!group_list.length">
            <td :colspan="5" :class="$style.tCenter">{{
              $t('member_group_list.msg_no_membership_group')
            }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ElDialog
      :title="
        target_group_seq
          ? $t('member_group_list.group_modification')
          : $t('member_group_list.group_registration')
      "
      :visible.sync="show_group_info"
      width="1240px"
    >
      <MemberGroupInfo
        v-if="show_group_info"
        :key="target_group_seq"
        :group_seq="target_group_seq"
        @submit="handleGroupSubmit"
      ></MemberGroupInfo>
    </ElDialog>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@src/design/default.scss';
@import '@src/design/admin.scss';
@import '@src/design/font.scss';
@import '@src/design/button.scss';
</style>
